<template>
    <div class="redirectUrl">
    </div>
</template>
<script>
export default {
  name: "redirectUrl",
  data() {
    return {};
  },
  mounted() {
    const self = this;
    const token = self.$route.query.token;
    const uid = self.$route.query.uid;
    const status = self.$route.query.status;
    // const name = self.$route.query.name;
    // const orgId = self.$route.query.orgId;

    if (token && status ) {
      const regEmailStatus = JSON.stringify(self.$route.query);
      localStorage.setItem("regEmailStatus", regEmailStatus);
      if (status == 0) {
        self.$router.push({ name: 'RegCoremail'})
      } else if (status == 1) {
        self.$router.push({ name: 'Home'})
        self.$alert("学校邮箱<span style='font-weight:600;'>"+uid+"</span>@tongji.edu.cn已注册，如若忘记密码，请先 <a href='/forgetPwd/step1' style='color:#198bfd;text-decoration:underline;'>找回密码</a>", '错误提示', {
                          confirmButtonText: '确定',
                          dangerouslyUseHTMLString: true,
                          type: 'error',
                          center: true,
                          customClass:'errMessage',
                          callback: action => {
                             window.location.href="https://mail.tongji.edu.cn/"
                          }
                        });
      } else if (status == 2) {
        self.$router.push({ name: 'ChoseType'})
      }else if (status == 4) {
         self.$router.push({ name: 'Home'})
         self.$alert("数据尚未录入注册系统，请第二天重试", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: action => {
            //self.$router.push({ name: 'Home'})
            window.location.href="https://mail.tongji.edu.cn/"
          }
        });
      } else if (status == 5) {
         self.$router.push({ name: 'Home'})
         self.$alert("该账号已注销", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: action => {
           // self.$router.push({ name: 'Home'})
           window.location.href="https://mail.tongji.edu.cn/"
          }
        });
      } else {
        self.$router.push({ name: 'Home'})
        self.$alert("系统错误，请稍后再试", "错误提示", {
          confirmButtonText: "确定",
          type: "error",
          center: true,
          customClass: "errMessage",
          callback: action => {
           // self.$router.push({ name: 'Home'})
           window.location.href="https://mail.tongji.edu.cn/"
          }
        });
      }
    } else {
      self.$router.push({ name: 'Home'})
      self.$alert("系统错误，请稍后再试", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        center: true,
        customClass: "errMessage",
        callback: action => {
          self.$router.push({ name: 'Home'})
        }
      });
     }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/Coremail/redirectUrl.vue